import React, { useState, useCallback, useRef } from "react";
import { View, StyleSheet, Text }               from "react-native";
import { AsYouType, parsePhoneNumber }          from "libphonenumber-js";

import StyledInput                              from "../StyledInput";
import Row                                      from "../../layouts/Row";
import Col                                      from "../../layouts/Col";
import palette                                  from "../../styles/palette";
import COUNTRIES                                from "../../constants/countries";

export default function PhoneInput({
  defaultValue = "",
  onChange,
  label,
  required,
  country = "US",
  ...props
}) {
  const [phone, setPhone] = useState(defaultValue);
  const [countryCode, setCountryCode] = useState(defaultValue);
  const [areaCode, setAreaCode] = useState(defaultValue);

  let pnRef = useRef();

  const onBlur = useCallback(() => {
    const numString = new AsYouType().input(`${phone}`);
    try {
      const num = parsePhoneNumber(numString);
    } catch (e) {
      console.error(e);
    }
    onChange && onChange(numString);
  }, [phone, onChange]);

  const maxAreaCodeLength = countryCode.length === 3 ? 4 : 3;

  return (
    <View>
      <Row>
        {/* <Col maxWidth={75} mr={8}>
          <StyledInput
            innerRef={ccRef}
            placeholder={`+${COUNTRIES[country].phoneCode}`}
            center
            {...props}
            value={countryCode}
            maxLength={3}
            selectTextOnFocus
            onChangeText={(val) => {
              const value = `${val ? "+" : ""}${val.replaceAll("+", "")}`
              setCountryCode(
                new AsYouType().input(value)
              );
              if (value === "+1" || value.length === 3) pnRef.current.focus();
            }}
            onBlur={onBlur}
          />
        </Col> */}
        {/* <Col maxWidth={110} mr={8}>
          <StyledInput
            innerRef={acRef}
            center
            selectTextOnFocus
            maxlength={maxAreaCodeLength}
            placeholder="(area code)"
            {...props}
            value={areaCode}
            onChangeText={setAreaCode}
            onKeyPress={({ nativeEvent: { key } }) => {
              if (key === "Backspace" && !areaCode.length) {
                ccRef.current.focus();
              }
            }}
            onChangeText={(val) => {
              setAreaCode(val);
              if (val.length === maxAreaCodeLength) pnRef.current.focus();
            }}
            onBlur={onBlur}
          />
        </Col> */}
        <Col>
          <StyledInput
            innerRef={pnRef}
            selectTextOnFocus
            placeholder="(phone number)"
            {...props}
            value={phone}
            // onChangeText={setPhone}
            onChangeText={(val) => {
              setPhone(
                new AsYouType().input(`${val}`)
              );
            }}
            onBlur={onBlur}
            // onKeyPress={({ nativeEvent: { key } }) => {
            //   if (key === "Backspace" && !phone.length) {
            //     ccRef.current.focus();
            //   }
            // }}
          />
        </Col>
      </Row>
    </View>
  );
}

const styles = StyleSheet.create({
  field_label: {
    padding: 8,
  },
  field_label_required: {
    color: palette.grey,
    fontWeight: "600",
  },
  field_label_text: {
    fontSize: 14,
    color: palette.dark,
    fontFamily: "acumin-pro, san-serif",
  },
});
